import PurchaseBusinessService from '../../purchase-business-service';
import Service from '@/service/index.js';
export default {
  components: {
  },
  data() {
    return {
      purchaseId: '',
      contractFile: []
    };
  },
  created() {
    this.purchaseId = this.$route.query.id;
    this.getPurchaseFile();
  },
  computed: {
  },
  methods: {
    // 获取项目文件的接口
    getPurchaseFile () {
      PurchaseBusinessService.getContractingFileList(this.purchaseId, 2).then(res => {
        if (res && res.code === '0') {
          res.data.forEach(item => {
            this.getProjectContractUrl(item);
          });
        }
      });
    },
    // 获取码值对应表
    getProjectContractUrl (itemC) {
      Service.getSelectList('PURCHASE_CONTRACT_TYPE').then(res => {
        if (res && res.code === '0') {
          res.data.forEach(item => {
            if(item.code === String(itemC.contractType)) {
              this.contractFile.push({...item, url: itemC.url});
              console.log(this.contractFile);
            }
          });
        }
      });
    },
    // 打开合同路径
    openWindow (key) {
      window.open(key.url);
    }
  }
};
